export default __webpack_public_path__ + "static/media/poster.c9d6ab4e.png";